import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import momentJalaali from "moment-jalali";
import { useState, Fragment, useRef, useEffect, useCallback } from "react";
import DatePicker from "react-datepicker2";
import { useHistory, useParams } from "react-router-dom";
import { Card, Button, Table, Row, Col, FormGroup, Form, Popover, OverlayTrigger, Alert } from "react-bootstrap";
import NewNumberInput from "../../Components/NewNumberInput";
import ModalAccountLevel3 from "../../Components/Modals/ModalAccountLevel3";
import ModalReminder from "../../Components/Modals/ModalReminder";
import { getDocumentNumber, addEditDocument, getDocument, getAttachmentList, getPrvNextDocumentID, makeDocumentPermanet, makeDocumentTemporary, accountsBookReport } from "../store/api/DocumentsAPI";
import { PlusSquare, DashCircle, List, CheckLg, PlusCircle, PersonPlusFill, PersonCheckFill, Calendar2DateFill, Calendar2CheckFill, Pencil, PencilFill, JournalBookmarkFill, Printer, Link45deg, CloudUploadFill, Trash, Download, Command, Toggle2On, Toggle2Off, CalendarDay, CalendarDate, MenuApp, ExclamationTriangle, FileEarmarkPlus, Files } from "react-bootstrap-icons";
import { keyIsLetterOrNumber, networkManager_CheckOut, networkManager_CheckIn, setErrorDialog, isWebApp, attachFile, downloadFile, deleteAttachment, documentStatuses, useIsMobileApp } from "../../store/api/CommonFunctions";
import ModalSelectCostCenter from "../Components/ModalSelectCostCenter";
import { useDispatch } from "react-redux";
import "react-datepicker2/src/styles/style.css";
import ModalAccountsLevel2 from "../Components/ModalAccountsLevel2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen, faCaretSquareLeft, faCaretSquareRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import ModalCommands from "../../Components/Modals/ModalCommands";

const AddEditDocument = () => {
    const isCopy = useRef(false);
    const [attachList, setAttachList] = useState(null);
    const frmNewRow = useRef();
    const inputLongDescRef = useRef();
    const inputAttach = useRef();
    const history = useHistory();
    const checkOut = useRef(true);
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const iconClicked = useRef(false);
    const { documentID } = useParams();
    const [docRows, setDocRows] = useState([]);
    const [docError, setDocError] = useState({});
    const [showAddRow, setAddRow] = useState(false);
    const [checkedIn, setCheckedIn] = useState(true);
    const [currentRow, setCurrentRow] = useState(null);
    const { register, handleSubmit, errors } = useForm();
    const [selectedAccount, selectAccount] = useState(null);
    const [showCostCenter, setShowCostCenter] = useState(true);
    const [popReminder, setPopReminder] = useState({ show: false });
    const [selectedAccountL2, selectAccountL2] = useState(null);
    const [selectedCostCenter, selectCostCenter] = useState(null);
    const [popCommand, setPopCommand] = useState({ show: false });
    const [popAccLevel2, setPopAccLevel2] = useState({ show: false });
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    const [popCostCenter, setPopCostCenter] = useState({ show: false });
    const [accDoc, setDocument] = useState({
        DocumentDate: momentJalaali().local("en").format("YYYY-MM-DD HH:mm"),
        DocumentNumber: 0, TotalDebit: 0, TotalCredit: 0, RemainedAmount: 0
    });
    const handleKeyPress = useCallback((event) => {
        if (event.altKey && (event.code === "KeyN")) {
            showAddDiv();
        }
        if (event.altKey && (event.code === "KeyZ")) {
            setAddRow(false);
        }
        if (Number(documentID) > 0) {
            if (event.altKey && event.code === "KeyC") {
                copyDocument();
            }
            if (event.altKey && event.code === "KeyR") {
                showModalReminder();
            }
            if (event.altKey && event.code === "KeyP") {
                printDoc(event);
            }
            if (event.altKey && event.code === "KeyM") {
                showCommand();
            }
            if (event.altKey && event.code === "KeyV") {
                gotoNewDocument();
            }
        }
        // if(event.altKey && event.code ==="KeyL")
        // {
        //     submitDocument();
        // }
    }, []);
    function setNetCheckIn(res) {
        if (res.Message || res.Error) {
            checkOut.current = false;
            setCheckedIn(false);
        }
        else {
            checkOut.current = true;
            setCheckedIn(true);
        }
    }
    function loadAttachList() {
        if (attachList === null) {
            getAttachmentList(documentID, setAttachList);
        }
    }
    function delAttach(id) {
        dispatch(deleteAttachment(id, "DocumentAttachment", () => getAttachmentList(documentID, setAttachList)));
    }

    function getDoc() {
        const onGetDocument = (data) => {
            if (data.Error) {
                setErrorDialog(dispatch, data.Error, "دریافت سند حسابداری");
            }
            else if (data.DocumentRows) {
                data.TotalCredit = data.DocumentRows.filter(r => !r.RowAccountType).map(d => d.RowAmount).reduce((a, b) => a + b, 0);
                data.TotalDebit = data.DocumentRows.filter(r => r.RowAccountType).map(d => d.RowAmount).reduce((a, b) => a + b, 0);
                data.DocumentRows.forEach(r => {
                    r.Debit = r.RowAccountType ? r.RowAmount : 0;
                    r.Credit = !r.RowAccountType ? r.RowAmount : 0;
                });
                data.RemainedAmount = data.TotalCredit - data.TotalDebit;
                setDocument(data);
                setDocRows(data.DocumentRows);
                window.addEventListener('beforeunload', onClose);
                dispatch(networkManager_CheckIn({ DocType: "Document", DocID: documentID }, setNetCheckIn));
            }
            else if (data === "PENDING") {
                setDocument("PENDING");
            }
        }
        getDocument(documentID, onGetDocument);
    }
    const showAddDiv = useCallback(() => {
        const f = async () => {
            setAddRow(true);
        }
        f().then(() => {
            const inputAccL2Name = document.getElementById("inputAccL2Name");
            inputAccL2Name.focus();
        }
        );
    }, []);
    function addNewRow(data) {
        if (Array.isArray(data.RowAccountType)) {
            data.RowAccountType = data.RowAccountType.some(r => r === "on");
        }
        if (data.RowAccountType) {
            accDoc.TotalDebit += Number(data.RowAmount);
        }
        else {
            accDoc.TotalCredit += Number(data.RowAmount);
        }
        accDoc.RemainedAmount = accDoc.TotalCredit - accDoc.TotalDebit;
        setDocRows([...docRows,
        {
            ...data,
            Index: docRows.length + 1,
            Credit: !data.RowAccountType ? Number(data.RowAmount) : 0,
            Debit: data.RowAccountType ? Number(data.RowAmount) : 0
        }]);
        selectCostCenter(null);
        selectAccount(null);
        selectAccountL2(null);
        // The Following Three Lines Were Removed To Be Offered As Default In The Next Line
        //const inputRowAmount = document.getElementsByName("RowAmount")[0];
        //inputRowAmount.parentElement.setAttribute("comma-value", "0");
        //frmNewRow.current.reset();
        const inputAccL2Name = document.getElementById("inputAccL2Name");
        inputAccL2Name.focus();

    }
    function editRow(data) {

        const oldRow = Number(data.RowID) > 0 ? docRows.find(r => Number(r.RowID) === Number(data.RowID)) :
            docRows.find(r => Number(r.Index) === Number(data.Index)); // Second Condition For New Rows
        if (Array.isArray(data.RowAccountType)) {
            data.RowAccountType = oldRow.RowAccountType;// data.RowAccountType.some(r => r === "on");
        }
        if (data.RowAccountType) {
            accDoc.TotalDebit += Number(data.RowAmount);
        }
        else if (!data.RowAccountType) {
            accDoc.TotalCredit += Number(data.RowAmount);
        }
        if (oldRow.RowAccountType) {
            accDoc.TotalDebit -= Number(oldRow.RowAmount);
        }
        else if (!oldRow.RowAccountType) {
            accDoc.TotalCredit -= Number(oldRow.RowAmount);
        }
        accDoc.RemainedAmount = accDoc.TotalCredit - accDoc.TotalDebit;
        Object.assign(oldRow, data);
        oldRow.Credit = !data.RowAccountType ? Number(data.RowAmount) : 0;
        oldRow.Debit = data.RowAccountType ? Number(data.RowAmount) : 0;
        selectCostCenter(null);
        selectAccount(null);
        setCurrentRow(null);
        selectAccountL2(null);
    }
    function removeRow(row) {
        iconClicked.current = true;
        if (row.Debit > 0) {
            accDoc.RemainedAmount += row.Debit;
            accDoc.TotalDebit -= row.Debit;
        }
        else if (row.Credit > 0) {
            accDoc.RemainedAmount -= row.Credit;
            accDoc.TotalCredit -= row.Credit;
        }
        if (row.RowID) {
            docRows.find(d => d.Index === row.Index).SignedForDelete = true;
            setDocRows([...docRows]);
        }
        else {
            setDocRows([...docRows.filter(i => i.Index !== row.Index)]);
        }
    }
    function cancelRow() {
        selectAccountL2(null);
        selectAccount(null);
        selectCostCenter(null);
        setAddRow(false);
        setCurrentRow(null);
        setDocError({ ...docError, IsInEditMode: null });
    }
    function showModalAccLevel3(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            if (data) {
                if (data.CostCenterID) {
                    if (!selectedCostCenter) {
                        selectCostCenter({ ID: data.CostCenterID, CenterName: data.CostCenterName });
                    }
                    else {
                        selectedCostCenter.ID = data.CostCenterID;
                        selectedCostCenter.CenterName = data.CostCenterName;
                    }
                }
                if (!selectedAccountL2 && !selectAccountL2.AccountID) {
                    selectAccountL2({ AccountID: data.AccountLevelTwoAccountID, AccountName: data.AccountLevelTwoAccountName, AccountCode: data.AccountLevelTwoCode });
                }
                selectAccount(data);
            }
        }
        setPopAccLevel3({ show: true, parentID: selectedAccountL2?.AccountID, setAccData: onSetData, value: e.key });
        const inputDesc = document.getElementsByName("RowDescription")[0];
        inputDesc.focus();
    }
    function showModalAccLevel2(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            if (data) {
                selectAccountL2(data);
                selectAccount(null);
            }
        }
        setPopAccLevel2({ show: true, setAccData: onSetData, value: e.key });
        const inputAcc = document.getElementById("AccL3Name");
        inputAcc.focus();
    }
    function showModalCostCenter(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            if (!data && currentRow) {
                currentRow.CostCenterID = null;
                currentRow.CostCenterName = null;
            }
            //if (data) {
            selectCostCenter(data);
            //}
        }
        setPopCostCenter({
            show: true,
            onSelect: onSelect
        });
        const inputRowAmount = document.getElementsByName("RowAmount")[0];
        inputRowAmount.focus();

    }
    function showHideCostCenter(e) {
        setShowCostCenter(e.target.checked);
    }
    function submitDocument() {

        if (showAddDiv) {
            setAddRow(false);
        }
        const err = {};
        if (accDoc.RemainedAmount !== 0) {
            err.Unbalanced = "سند موازنه نیست";
        }
        if (!docRows || !Array.isArray(docRows) || docRows.length === 0) {
            err.Unbalanced = "امکان ثبت سند بدون ردیف وجود ندارد";
        }
        const hasRow = docRows.some(d => !d.SignedForDelete);
        if (!hasRow) {
            err.Unbalanced = "امکان ثبت سند حسابداری بدون ردیف وجود ندارد."
        }
        setDocError(err);
        if (Object.keys(err).length > 0) {
            return;
        }
        accDoc.DocumentRows = docRows;
        if (!accDoc.DocumentID) {
            accDoc.DocumentID = 0;
        }
        setDocument("PENDING");
        const onSuccess = (res) => {
            if (res.Document) {
                const data = { ...res.Document };
                if (data.DocumentID) {
                    history.replace(`/Accounting/AddEditDocument/${data.DocumentID}`);
                    data.TotalCredit = data.DocumentRows.map(d => !d.RowAccountType ? 0 : d.RowAmount).reduce((a, b) => a + b, 0);
                    data.TotalDebit = data.DocumentRows.map(d => d.RowAccountType ? d.RowAmount : 0).reduce((a, b) => a + b, 0);
                    data.DocumentRows.forEach(r => {
                        r.Debit = r.RowAccountType ? r.RowAmount : 0;
                        r.Credit = !r.RowAccountType ? r.RowAmount : 0;
                    });
                    data.RemainedAmount = data.TotalCredit - data.TotalDebit;
                    setDocument(data);
                    setDocRows(data.DocumentRows);
                }
            }

        }
        dispatch(addEditDocument(accDoc, onSuccess));
    }
    function cancelDocument() {
        if (Number(documentID) > 0 && checkOut.current) {
            networkManager_CheckOut({ DocType: "Document", DocID: documentID });
        }
        setDocError(null);
        selectAccount(null);
        selectCostCenter(null);
        setAddRow(false);
        setCurrentRow(null);
        if (Number(documentID) > 0) {
            getDoc();
        }
        else {
            setDocument(
                {
                    DocumentDate: momentJalaali().local("en").format("YYYY-MM-DD HH:mm"),
                    DocumentNumber: 0, TotalDebit: 0, TotalCredit: 0, RemainedAmount: 0
                })
        }
    }
    function setCurrentRowForEdit(row) {
        if (iconClicked.current) {
            iconClicked.current = false;
            return;
        }
        if (currentRow) {
            setDocError({ IsInEditMode: "ابتدا ردیف پیشین را ثبت کنید" });
            return;
        }
        setCurrentRow(row);
    }
    function showBook(row) {
        iconClicked.current = true;
        //Because Of The Condition On The Accounting Book page, We Need To Search First And Then Go To The Accounting Book Page
        dispatch(accountsBookReport({ Skip: 0, Take: 10, Level: 3, AccountID: row.AccountID, AccountCat: row.AccountCat, }));
        //
        if (row.e?.ctrlKey) {
            window.open(`/Accounting/AccountingBook/3/${row.AccountID}/${row.AccountCat}`);
        }
        else {
            history.push(`/Accounting/AccountingBook/3/${row.AccountID}/${row.AccountCat}`);
        }
    }
    const onClose = useCallback((event) => {
        event.preventDefault();
        event.returnValue = "";
        if (Number(documentID) > 0 && checkOut.current) {

            networkManager_CheckOut({ DocType: "Document", DocID: documentID });
        }
        return "";
    })
    function printDoc(e) {
        history.push({
            pathname: `/PrintViewer/AccountingDocument/${e.ctrlKey ?? false}`,
            state: {
                dataUrl: `api/DocumentsAPI/GetDocument?documentID=${documentID}`,
                method: "get"
            }
        });
    }
    function attach() {
        dispatch(attachFile(inputAttach.current, documentID, "DocumentAttachment", () => getAttachmentList(documentID, setAttachList)));
    }
    function showCommand() {
        setPopCommand({
            show: true,
            attachmentType: "AccountingDocument",
            attachmentID: documentID
        })
    }
    function gotoPrvNextDoc(next) {
        const onSuccess = (res) => {
            if (Number(res.ID) >= 0) {
                history.push(`/Accounting/AddEditDocument/${res.ID}`);
                setAddRow(false);
                setDocError({});
                setCurrentRow(null);
            }
        }
        getPrvNextDocumentID(documentID, next, onSuccess);
    }
    function gotoNewDocument() {
        history.push(`/Accounting/AddEditDocument/0`);
    }
    function permanetDocument() {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "دائمی کردن سند حسابداری");
            }
            else {
                setErrorDialog(dispatch, "success", "دائمی کردن سند حسابداری");
                setDocument({ ...accDoc, DocumentStatusID: 2, PDocumentStatus: "دائــم" });
            }
        }
        makeDocumentPermanet(documentID, onSuccess);
    }
    function tempDocument() {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "خروج سند از وضعیت دائمی");
            }
            else {
                setErrorDialog(dispatch, "success", "خروج سند از وضعیت دائمی");
                setDocument({ ...accDoc, DocumentStatusID: 1, PDocumentStatus: "موقت" });
            }
        }
        makeDocumentTemporary(documentID, onSuccess);
    }
    function showModalReminder() {
        setPopReminder({
            show: true
        })
    }
    function copyDocument() {
        isCopy.current = true;
        history.push(`/Accounting/AddEditDocument/0`);
    }
    function handleDescBtnClick(e) {

        setTimeout(() => {
            inputLongDescRef.current.select();
        }, 20);

    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کدحساب", colName: "AccountCode", showInMobile: false, colType: "string" },
        { colTitle: "نام حساب", colName: "AccountL2Name+AccountName", showInMobile: true, colType: "string" },
        { colTitle: "شرح ردیف", colName: "RowDescription", showInMobile: false },
        { colTitle: "مرکز هزینه", colName: "CostCenterName", showInMobile: false, colType: "string", showCondition: () => showCostCenter },
        { colTitle: "بدهکار", colName: "Debit", showInMobile: true, colType: "currency" },
        { colTitle: "بستانکار", colName: "Credit", showInMobile: true, colType: "currency" }
    ]
    const tableRowButtons = [
        {
            title: "ویرایش ردیف",
            type: "common",
            tooltip: "ویرایش ردیف",
            className: "group-Btn-smalll btn-secondary",
            icon: <PencilFill className="rowBtn" color="orange" size={18} />,
            onclick: setCurrentRowForEdit,
            showCondition: () => !(Number(accDoc.AttachmentID) > 0)
        },
        {
            title: "دفتر حساب",
            type: "common",
            tooltip: "دفتر حساب(برای باز شدن در تب جدید کلید کنترل را نگه دارید)",
            className: "group-Btn-smalll btn-info",
            icon: <JournalBookmarkFill className="rowBtn" color="#de2897" size={18} />,
            onclick: showBook
        },
        {
            title: "حذف ردیف",
            type: "delete",
            className: "group-Btn-smalll btn-danger",
            onclick: removeRow,
            showCondition: () => !(Number(accDoc.AttachmentID) > 0)
        }
    ]
    const popover = (
        (<Popover id="popover-basic" style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Button className="btn-input-tiny" style={{ top: "1px", left: "1px" }} onClick={attach}><CloudUploadFill size={25} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>تاریخ پیوست</th>
                            <th style={{ width: "50%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            attachList && Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "65%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "DocumentAttachment")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    const popShortKeys = (
        <Popover id="popShortKeys">
            <Popover.Content className="bodyStyle" style={{ fontFamily: "Vazir", fontSize: "11px", color: "blue" }}>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+C:</span> تکرار سند</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+R:</span> یادآوری</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+M:</span> دستور کار</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+N:</span> ردیف جدید</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+P:</span> چاپ سند</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+V:</span> سند جدید</label>
                {/* <label style={{ padding: 0, display: "block" }}><span style={{fontWeight:"bold"}}>ALT+L:</span> ثبت سند</label> */}
            </Popover.Content>
        </Popover>
    )
    const menuPopOver = (
        (
            <Popover id="popover-menu" style={{ fontSize: "13px", fontFamily: "Vazir" }}>
                <Popover.Title className="headerStyle" style={{ padding: "4px" }}>
                    <MenuApp size={14} />&nbsp;
                </Popover.Title>
                <Popover.Content className="bodyStyle" style={{ padding: "4px" }}>
                    <div onClick={printDoc} className="popMenuItem"><Printer size={15} />&nbsp; چاپ سند</div>
                    <div className="popMenuItem" onClick={showCommand}><Command />&nbsp; دستور کار</div>
                    <div className="popMenuItem" onClick={showModalReminder}><CalendarDate size={15} />&nbsp; یادآوری</div>
                    {Number(accDoc?.DocumentStatusID) === documentStatuses.Temp && <div className="popMenuItem" onClick={permanetDocument} disabled={!checkedIn}><Toggle2On size={18} />&nbsp;دائمی کردن سند</div>}
                    {Number(accDoc?.DocumentStatusID) === documentStatuses.Permanet && <div className="popMenuItem" onClick={tempDocument} disabled={!checkedIn}><Toggle2Off size={18} />&nbsp;خروج از وضعیت دائمی</div>}
                </Popover.Content>
            </Popover>
        )
    )
    const popRowDesc = (
        <Popover style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir", backgroundColor: "#e3ecf2" }}>
            <Popover.Content>
                <textarea className="form-control" rows={3} ref={inputLongDescRef} autoFocus id="desc"
                    style={{ fontSize: "12px", backgroundColor: "inherit", borderColor: "#a8aeb1" }}
                    defaultValue={currentRow?.RowDescription} onChange={e => setCurrentRow({ ...currentRow, RowDescription: e.target.value })} />
            </Popover.Content>
        </Popover>
    )
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
        document.addEventListener('keydown', handleKeyPress);
        if (!documentID || Number(documentID) < 1) {
            if (docRows.length > 0) {
                setDocRows([]);
            }
            const onGetDocNumber = (number) => {
                if (number === "PENDING") {
                    setDocument("PENDING");
                    return;
                }
                if (!isCopy.current) {
                    setDocument({
                        DocumentDate: momentJalaali().local("en").format("YYYY-MM-DD HH:mm"),
                        DocumentNumber: number,
                        TotalCredit: 0,
                        TotalDebit: 0,
                        RemainedAmount: 0
                    });
                }
                else {
                    isCopy.current = false;
                    const newDoc = { ...accDoc };
                    newDoc.DocumentRows.forEach(r => { r.DocumentID = 0; r.RowID = 0; });
                    setDocument({
                        DocumentDate: momentJalaali().local("en").format("YYYY-MM-DD HH:mm"),
                        DocumentNumber: number,
                        TotalCredit: newDoc.TotalCredit,
                        TotalDebit: newDoc.TotalDebit,
                        RemainedAmount: newDoc.RemainedAmount
                    });
                    setDocRows(newDoc.DocumentRows);
                }
            }
            getDocumentNumber(onGetDocNumber);
        }
        else if (Number(documentID) > 0) {
            getDoc();
        }
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
            window.removeEventListener('beforeunload', onClose);
            if (Number(documentID) > 0 && checkOut.current) {
                networkManager_CheckOut({ DocType: "Document", DocID: documentID });
            }
        };
    }, [documentID, handleKeyPress]);
    return (
        <div className="container-fluid mt-1">
            <br />
            <ModalCommands popData={popCommand} setPopData={setPopCommand} />
            <ModalSelectCostCenter popData={popCostCenter} setPopCostCenter={setPopCostCenter} />
            <ModalAccountsLevel2 popData={popAccLevel2} setPopData={setPopAccLevel2} />
            <ModalReminder pop={popReminder} setPop={setPopReminder} attachmentID={documentID} attachmentType="acc_doc" />
            {popAccLevel3.show && <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />}
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faBookOpen} size="lg" />
                    &nbsp;
                    سند حسابداری&nbsp;
                    {accDoc?.PDocumentStatus && <label style={{ padding: "2px 10px 2px 10px", border: "2px solid blue", transform: "rotate(-30deg)", boxShadow: "0 0 3px blue", letterSpacing: "0.75px" }}>{accDoc.PDocumentStatus}</label>}
                    {Number(accDoc?.AttachmentID) > 0 && 
                    <label style={{ padding: "2px 10px 2px 10px", border: "2px solid green", transform: "rotate(-20deg)", boxShadow: "0 0 4px green", letterSpacing: "0.75px" }}>
                        سند خودکار
                        </label>}
                    {!isMobile &&
                        <Col md={1} style={{ position: "absolute", left: "50%", right: "50%", top: "5px" }}>
                            <label className="tooltipBtn" data-tooltip="سند بعدی">
                                <FontAwesomeIcon icon={faCaretSquareRight} color="#c0c0e0" size="2x" style={{ marginLeft: "5px" }} onClick={() => gotoPrvNextDoc(true)} />
                            </label>
                            <label className="tooltipBtn" data-tooltip="سند قبلی">
                                <FontAwesomeIcon icon={faCaretSquareLeft} color="#c0c0e0" size="2x" onClick={() => gotoPrvNextDoc(false)} />

                            </label>
                        </Col>
                    }
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    {accDoc === "PENDING" &&
                        <div style={{ textAlign: "center" }}>
                            <Loader type="BallTriangle" color="#bb1370" width="30" height="30" />
                        </div>}
                    {accDoc && accDoc !== "PENDING" &&
                        <Fragment>
                            {docError?.Unbalanced &&
                                <Alert variant="danger" style={{ width: "25rem" }}>
                                    <ExclamationTriangle size={14} />&nbsp;
                                    {docError.Unbalanced}
                                </Alert>}
                            <Row>
                                {isMobile && (Number(documentID) > 0) &&
                                    <Fragment>
                                        <Col md={2} style={{ fontSize: "11px", color: "blue", paddingTop: "8px" }} className="rowBorder">
                                            {
                                                accDoc.PDocumentCreationDate !== undefined && accDoc.PDocumentCreationDate.length > 0 &&
                                                <div style={{ float: "left", textAlign: "right", minWidth: "150px" }}>
                                                    &nbsp;<Calendar2DateFill size={14} color="#2894b1" /><label>&nbsp;تاریخ ثبت: {accDoc.PDocumentCreationDate}</label>
                                                </div>
                                            }
                                            {accDoc.CreateByName !== undefined && accDoc.CreateByName.length > 0 &&
                                                <div style={{ float: "left", textAlign: "right", minWidth: "150px" }}>
                                                    <PersonPlusFill size={17} color="#ff5e00" /><label>&nbsp;ثبت کننده: {accDoc.CreateByName}</label>
                                                </div>
                                            }
                                            {
                                                accDoc.PUpdateDate?.length > 0 &&
                                                <div style={{ float: "left", textAlign: "right", minWidth: "150px", marginTop: "3px" }}>
                                                    &nbsp;<Calendar2CheckFill size={14} color="#bc1d72" /><label>&nbsp;تاریخ ویرایش: {accDoc.PUpdateDate}</label>
                                                </div>
                                            }
                                            {accDoc.UpdateByName !== undefined && accDoc.UpdateByName.length > 0 &&
                                                <div style={{ float: "left", textAlign: "right", minWidth: "150px" }}>
                                                    <PersonCheckFill size={17} color="#6e0bd0" /><label>&nbsp;ویرایش کننده: {accDoc.UpdateByName}</label>
                                                </div>
                                            }
                                        </Col>
                                    </Fragment>
                                }
                                <Col md={1} xs={4} className="form-group" >
                                    <label>شماره سند</label>
                                    <input type="text" className="form-control" value={accDoc.DocumentNumber ?? ""} readOnly />
                                </Col>
                                <Col md={2} xs={8} className="form-group" style={{ marginLeft: "auto" }}>
                                    <label>تاریخ و زمان صدور سند</label>
                                    <DatePicker isGregorian={false} timePicker={true} format="" className="form-control" onChange={value => { setDocument({ ...accDoc, DocumentDate: value.local("en").format("YYYY-MM-DD HH:mm") }) }}
                                        value={momentJalaali(accDoc.DocumentDate)} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" />
                                </Col>
                                {!isMobile &&
                                    <Fragment>
                                        <Col md={2} style={{ fontSize: "11px", color: "blue" }}>
                                            {
                                                accDoc.PDocumentCreationDate?.length > 0 &&
                                                <div style={{ float: "left", textAlign: "right", minWidth: "150px" }}>
                                                    &nbsp;<Calendar2DateFill size={14} color="#2894b1" /><label>&nbsp;تاریخ ثبت: {accDoc.PDocumentCreationDate}</label>
                                                </div>
                                            }
                                            {accDoc.CreateByName?.length > 0 &&
                                                <div style={{ float: "left", textAlign: "right", minWidth: "150px" }}>
                                                    <PersonPlusFill size={17} color="#ff5e00" /><label>&nbsp;ثبت کننده: {accDoc.CreateByName}</label>
                                                </div>
                                            }
                                            {
                                                accDoc.PUpdateDate?.length > 0 &&
                                                <div style={{ float: "left", textAlign: "right", minWidth: "150px", marginTop: "3px" }}>
                                                    &nbsp;<Calendar2CheckFill size={14} color="#bc1d72" /><label>&nbsp;تاریخ ویرایش: {accDoc.PUpdateDate}</label>
                                                </div>
                                            }
                                            {accDoc.UpdateByName?.length > 0 &&
                                                <div style={{ float: "left", textAlign: "right", minWidth: "150px" }}>
                                                    <PersonCheckFill size={17} color="#6e0bd0" /><label>&nbsp;ویرایش کننده: {accDoc.UpdateByName}</label>
                                                </div>
                                            }
                                        </Col>
                                    </Fragment>
                                }
                            </Row>
                            <Row className="mt-2">
                                <Col md={1} style={{ marginLeft: "auto" }}>
                                    {!showAddRow && <Button className="group-Btn-smalll mt-1" onClick={showAddDiv} disabled={Number(accDoc?.AttachmentID) > 0}><PlusSquare size={18} /></Button>}
                                </Col>
                                <Col md={2} style={{ justifyContent: "end", alignItems: "end", display: "flex" }}>
                                    <input type="checkbox" style={{ margin: "2px" }} className="form-check-input-small" onChange={showHideCostCenter} defaultChecked={showCostCenter} />
                                    <span style={{ color: "#f20c92" }}>نمایش مرکز هزینه</span>
                                </Col>
                            </Row>
                            {(showAddRow || currentRow) &&
                                <form onSubmit={handleSubmit(currentRow?.RowID !== undefined ? editRow : addNewRow)} readOnly ref={frmNewRow}>
                                    <div style={{ overflowX: "auto" }}>
                                        <div className="form-group" style={{ border: "1px solid gray", padding: "8px", borderRadius: "3px", backgroundColor: "#cdd7e273", minWidth: !isMobile ? "1190px" : 0, position: "relative" }} >
                                            {!isMobile &&
                                                <table className="flexTable">
                                                    <thead>
                                                        <tr>
                                                            <th>حساب معین</th>
                                                            <th>حساب تفصیلی</th>
                                                            <th>شرح ردیف</th>
                                                            {showCostCenter && <th>مرکز هزینه</th>}
                                                            <th>مبلغ</th>
                                                            <th>بدهکار</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input type="hidden" value={currentRow?.Index ?? ""} readOnly name="Index" ref={register({})} />
                                                                <input type="hidden" value={currentRow?.RowID ?? ""} readOnly name="RowID" ref={register({})} />
                                                                <input type="hidden" value={selectedAccountL2?.AccountID ?? currentRow?.AccountL2ID ?? ""} ref={register({ required: true })} name="AccountL2ID" />
                                                                <input ref={register({ required: true })} type="hidden" className="form-control tableRowInput" readOnly
                                                                    value={selectedAccountL2?.AccountCode ?? currentRow?.AccountL2Code ?? ""}
                                                                    name="AccountL2Code" />
                                                                <div>
                                                                    <input ref={register({ required: true })} type="text" className="form-control tableRowInput" readOnly id="inputAccL2Name"
                                                                        value={selectedAccountL2?.AccountName ?? currentRow?.AccountL2Name ?? ""} name="AccountL2Name" onKeyDown={showModalAccLevel2} />
                                                                    <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalAccLevel2} tabIndex={-1}><List size={16} /></Button>
                                                                </div>
                                                                {errors && errors.AccountL2ID && <small className="errors">انتخاب حساب معین الزامی است</small>}
                                                            </td>
                                                            <td>
                                                                <input type="hidden" value={selectedAccount?.AccountID ?? currentRow?.AccountID ?? ""} ref={register({ required: true })} name="AccountID" />
                                                                <input type="hidden" value={selectedAccount?.AccountCat ?? currentRow?.AccountCat ?? ""} ref={register({ required: true })} name="AccountCat" />
                                                                <input ref={register({ required: true })} type="hidden" className="form-control tableRowInput" readOnly
                                                                    value={selectedAccount ? selectedAccount.AccountLevelOCode +
                                                                        selectedAccount.AccountLevelOneCode +
                                                                        selectedAccount.AccountLevelTwoCode +
                                                                        selectedAccount.AccountLevelThreeCode : (currentRow?.AccountCode ?? "")}
                                                                    name="AccountCode" />
                                                                <div>
                                                                    <input ref={register({ required: true })} type="text" className="form-control tableRowInput" readOnly id="AccL3Name"
                                                                        value={selectedAccount?.AccountName ?? currentRow?.AccountName ?? ""} name="AccountName" onKeyDown={showModalAccLevel3} />
                                                                    <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalAccLevel3} tabIndex={-1}><List size={16} /></Button>
                                                                </div>
                                                                {errors && errors.AccountID && <small className="errors">انتخاب حساب الزامی است</small>}
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <input ref={register({ required: true })} type="text" className="form-control tableRowInput" name="RowDescription"
                                                                        value={currentRow?.RowDescription ?? ""} onChange={e => setCurrentRow({ ...currentRow, RowDescription: e.target.value })} />
                                                                    {errors && errors.RowDescription && <small className="errors">وارد کردن شرح ردیف الزامی است</small>}
                                                                    {currentRow?.RowDescription?.length > 20 &&
                                                                        <OverlayTrigger overlay={popRowDesc} trigger="click" rootClose placement="left">
                                                                            <Button className="btn-input-tiny" style={{ top: 2, left: 2 }} onClick={handleDescBtnClick}><List size={17} /></Button>
                                                                        </OverlayTrigger>
                                                                    }
                                                                </div>
                                                            </td>
                                                            {showCostCenter &&
                                                                <td>
                                                                    <div>
                                                                        <input type="hidden" ref={register({})} name="CostCenterID" readOnly value={selectedCostCenter?.ID ?? currentRow?.CostCenterID ?? ""} />
                                                                        <input ref={register({})} type="text" className="form-control tableRowInput" name="CostCenterName" readOnly
                                                                            onKeyDown={showModalCostCenter} value={selectedCostCenter?.CenterName ?? currentRow?.CostCenterName ?? ""} />
                                                                        <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalCostCenter} tabIndex={-1}><List size={16} /></Button>
                                                                    </div>
                                                                </td>
                                                            }
                                                            <td>

                                                                <NewNumberInput reff={register({ required: true })} className="tableRowInput" inputname="RowAmount" defaultValue={currentRow?.RowAmount ?? ""} />
                                                                {errors && errors.RowAmount && <small className="errors">وارد کردن مبلغ الزامی است</small>}
                                                            </td>
                                                            <td>
                                                                <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                                                                    <input ref={register({})} type="checkbox" className="form-check-input" name="RowAccountType" style={{ verticalAlign: "middle", marginRight: "5px" }}
                                                                        defaultChecked={currentRow?.RowAccountType !== undefined ? currentRow?.RowAccountType : true} />
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            }
                                            {isMobile &&
                                                <Row>
                                                    <FormGroup>
                                                        <label>حساب معین: </label>
                                                        <input type="hidden" value={currentRow?.Index ?? ""} readOnly name="Index" ref={register({})} />
                                                        <input type="hidden" value={currentRow?.RowID ?? ""} readOnly name="RowID" ref={register({})} />
                                                        <input type="hidden" value={selectedAccountL2?.AccountID ?? (currentRow?.AccountL2ID ?? "")} ref={register({ required: true })} name="AccountL2ID" />
                                                        <input ref={register({ required: true })} type="hidden" readOnly value={selectedAccountL2 ? selectedAccountL2.AccountCode
                                                            : (currentRow?.AccountL2Code ?? "")}
                                                            name="AccountL2Code" />
                                                        <Form.Control ref={register({ required: true })} readOnly id="inputAccL2Name"
                                                            value={selectedAccountL2?.AccountName ?? (currentRow?.AccountL2Name ?? "")} name="AccountL2Name" onKeyDown={showModalAccLevel2} />
                                                        <Button className="btn-input-tiny" onClick={showModalAccLevel2}><List size={16} /></Button>
                                                        {errors && errors.AccountL2ID && <small className="errors">انتخاب حساب معین الزامی است</small>}
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <label>حساب تفصیلی: </label>
                                                        <input type="hidden" value={selectedAccount?.AccountID ?? currentRow?.AccountID ?? ""} ref={register({ required: true })} name="AccountID" />
                                                        <input type="hidden" value={selectedAccount?.AccountCat ?? currentRow?.AccountCat ?? ""} ref={register({ required: true })} name="AccountCat" />
                                                        <input ref={register({ required: true })} type="hidden" readOnly
                                                            value={selectedAccount ? selectedAccount.AccountLevelOCode +
                                                                selectedAccount.AccountLevelOneCode +
                                                                selectedAccount.AccountLevelTwoCode +
                                                                selectedAccount.AccountLevelThreeCode : (currentRow?.AccountCode ?? "")}
                                                            name="AccountCode" />
                                                        <Form.Control ref={register({ required: true })} readOnly id="AccL3Name"
                                                            value={selectedAccount?.AccountName ?? currentRow?.AccountName ?? ""} name="AccountName" onKeyDown={showModalAccLevel3} />
                                                        <Button className="btn-input-tiny" onClick={showModalAccLevel3}><List size={16} /></Button>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <label>شرح ردیف</label>
                                                        <Form.Control ref={register({ required: true })} type="text" name="RowDescription" defaultValue={currentRow?.RowDescription ?? ""} />
                                                        {errors && errors.RowDescription && <small className="errors">وارد کردن شرح ردیف الزامی است</small>}
                                                    </FormGroup>
                                                    {showCostCenter &&
                                                        <FormGroup>
                                                            <label>مرکز هزینه: </label>
                                                            <input type="hidden" ref={register({})} name="CostCenterID" readOnly value={selectedCostCenter?.ID ?? currentRow?.CostCenterID ?? ""} />
                                                            <Form.Control ref={register({})} name="CostCenterName" readOnly
                                                                onKeyDown={showModalCostCenter} value={selectedCostCenter?.CenterName ?? currentRow?.CostCenterName ?? ""} />
                                                            <Button className="btn-input-tiny" onClick={showModalCostCenter}><List size={16} /></Button>
                                                        </FormGroup>
                                                    }
                                                    <FormGroup>
                                                        <label>مبلغ: </label>
                                                        <NewNumberInput reff={register({ required: true })} inputname="RowAmount" defaultValue={currentRow?.RowAmount ?? ""} />
                                                        {errors && errors.RowAmount && <small className="errors">وارد کردن مبلغ الزامی است</small>}
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <input ref={register({})} type="checkbox" className="form-check-input" name="RowAccountType" style={{ verticalAlign: "middle", marginRight: "5px" }}
                                                            defaultChecked={currentRow ? currentRow.RowAccountType : true} /> &nbsp;
                                                        <label style={{ color: "blue", marginTop: "2px" }}>بدهکار</label>
                                                    </FormGroup>
                                                </Row>
                                            }
                                            {currentRow?.RowID !== undefined ?
                                                <Button className="group-Btn mt-2" type="submit"><Pencil size={16} />&nbsp;ویرایش ردیف</Button>
                                                :
                                                <Button className="group-Btn mt-2" type="submit"><PlusCircle size={16} />&nbsp;افزودن به جدول</Button>

                                            }
                                            <Button variant="danger" className="group-Btn mt-2" onClick={cancelRow} disabled={Number(accDoc?.AttachmentID) > 0}><DashCircle size={16} />&nbsp;انصراف</Button>
                                            {!isMobile &&
                                                <div style={{ fontSize: "10.5px", position: "absolute", left: "3px", color: "blue", bottom: "2px" }}>
                                                    <label style={{ padding: 0, display: "block" }}>TAB: حرکت به فیلد بعدی</label>
                                                    <label style={{ padding: 0, display: "block" }}>ENTER: افزودن به جدول</label>
                                                    <label style={{ padding: 0, display: "block" }}>SPACE: انتخاب حساب/مرکز هزینه</label>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </form>
                            }
                            <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} rowClick={(item) => setCurrentRowForEdit({ ...item })} dataList={{ Data: docRows ? docRows.filter(d => !d.SignedForDelete) : [] }} maxHeight={390} className="mb-0 mt-0" />
                            {docError?.IsInEditMode &&
                                <Alert variant="danger" style={{ width: "25rem" }}>
                                    <ExclamationTriangle size={14} />&nbsp;
                                    {docError.IsInEditMode}
                                </Alert>
                            }
                            <Col md={4} className="mb-1" style={{ float: "left", background: "linear-gradient(45deg, rgba(205, 215, 226, 0.45), #afbbed00)", borderRadius: "3px", padding: "0 8px 8px 8px" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            {!isMobile && <td style={{ width: "250px" }}></td>}
                                            <td style={{ width: "250px" }}>بدهکار</td>
                                            <td style={{ width: "250px" }}>بستانکار</td>
                                            <td style={{ width: "250px" }}>مانده</td>
                                        </tr>
                                        <tr>
                                            {!isMobile && <td style={{ width: "250px", fontWeight: "bold" }}>جمع کل: </td>}
                                            <td style={{ color: "rgb(247 0 34)", width: "250px" }}>{accDoc.TotalDebit.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                            <td style={{ color: "#0e6d8b", width: "250px" }}>{accDoc.TotalCredit.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                            <td style={{ color: accDoc.RemainedAmount >= 0 ? "#0e6d8b" : "rgb(247 0 34)", width: "250px" }}>{Math.abs(accDoc.RemainedAmount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                            <div className="mt-5">
                                <Button variant="success" className="group-Btn-large" onClick={submitDocument} disabled={!checkedIn || Number(accDoc.AttachmentID) > 0 || Number(accDoc?.DocumentStatusID) === documentStatuses.Permanet}>
                                    {!(Number(documentID) > 0) &&
                                        <Fragment>
                                            <CheckLg />&nbsp; ثبت سند
                                        </Fragment>
                                    }
                                    {
                                        Number(documentID) > 0 &&
                                        <Fragment>
                                            <PencilFill />&nbsp; ویرایش سند
                                        </Fragment>
                                    }
                                </Button>
                                <Button variant="danger" className="group-Btn-large" onClick={cancelDocument} disabled={Number(accDoc?.AttachmentID) > 0}><DashCircle size={17} />&nbsp; انصراف</Button>
                                {
                                    Number(documentID) > 0 && !isMobile &&
                                    <Fragment>
                                        <Button variant="secondary" className="group-Btn-large" onClick={printDoc} style={{ marginRight: "12px" }}><Printer size={16} /> &nbsp;چاپ سند</Button>
                                        <OverlayTrigger trigger="click" placement="top" overlay={popover} rootClose>
                                            <Button variant="light" className="group-Btn-large btn-violet" onClick={loadAttachList}><Link45deg size={19} />&nbsp;پیوست ها</Button>
                                        </OverlayTrigger>
                                        <Button className="group-Btn-large" onClick={showCommand}><Command />&nbsp; دستور کار</Button>
                                        <Button className="group-Btn-large" variant="secondary" onClick={showModalReminder}><CalendarDate size={15} />&nbsp; یادآوری</Button>
                                        {Number(accDoc?.DocumentStatusID) === documentStatuses.Temp && <Button className="group-Btn-large" variant="info" onClick={permanetDocument} disabled={!checkedIn }><Toggle2On size={18} />&nbsp;دائمی کردن سند</Button>}
                                        {Number(accDoc?.DocumentStatusID) === documentStatuses.Permanet && <Button className="group-Btn-large" variant="info" onClick={tempDocument} disabled={!checkedIn}><Toggle2Off size={18} />&nbsp;خروج از وضعیت دائمی</Button>}
                                        <Button className="group-Btn-large" onClick={gotoNewDocument}><FileEarmarkPlus size={19} />&nbsp; صدور سند جدید</Button>
                                        <Button className="group-Btn-large" variant="success" onClick={copyDocument}><Files size={19} />&nbsp; تکرار سند</Button>
                                    </Fragment>
                                }
                                {
                                    Number(documentID) > 0 && isMobile &&
                                    <OverlayTrigger trigger="click" placement="top" overlay={menuPopOver} rootClose>
                                        <Button className="group-Btn-large btn-violet"><List size={20} /></Button>
                                    </OverlayTrigger>
                                }
                            </div>
                            {!isMobile &&
                                <OverlayTrigger trigger="hover" placement="top" overlay={popShortKeys}>
                                    <div className="col-md-2" style={{ textAlign: "left", color: "blue", fontSize: "11px", position: "absolute", left: "10px", bottom: "35px" }}>
                                        <FontAwesomeIcon icon={faInfoCircle} size="sm" />&nbsp;<label style={{ cursor: "pointer" }}>کلیدهای میانبر</label>
                                    </div>
                                </OverlayTrigger>
                            }
                        </Fragment>
                    }
                </Card.Body>
            </Card>
        </div>
    )
}
export default AddEditDocument;